import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircle } from "@fortawesome/free-solid-svg-icons";
import { Button } from "reactstrap";

const BillingHeader = ({
  cardComplete,
  cardEditable,
  handleCardHeaderEdit
}) => {
  return (
    <div className="checkout__step-header">
      <FontAwesomeIcon
        size="lg"
        icon={cardComplete ? faCheckCircle : faCircle}
      />
      <span className="checkout__step-number">2 of 3</span>
      <h2>Credit Card Information</h2>
      {cardEditable && (
        <Button
          id="cardHeader_editButton"
          outline
          color="primary"
          size="sm"
          onClick={() => {
            handleCardHeaderEdit();
          }}
        >
          Edit
        </Button>
      )}
    </div>
  );
};

export default BillingHeader;

BillingHeader.propTypes = {
  cardComplete: PropTypes.bool.isRequired,
  cardEditable: PropTypes.bool.isRequired,
  handleCardHeaderEdit: PropTypes.func.isRequired
};
